import { SearchUserHit } from 'lib-shared-types-api';
import _sortBy from 'lodash/sortBy';

import { getStatus } from './getStatus';

export const sortMembers = (
  members: readonly SearchUserHit[],
): SearchUserHit[] =>
  _sortBy(members, [
    (member) => {
      const rank = { working: 1, away: 2, offline: 3 };
      return rank[getStatus(member)];
    },
    (member) => member.display_name?.toLowerCase() ?? '',
  ]);
